module.exports = __webpack_public_path__ + "img/img-b458c4.png";